import { Component, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ForeCastService } from 'src/app/private/services/forecast.service';
import { PipeLineService } from 'src/app/private/services/pipeline.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import * as XLSX from 'xlsx';
import { TrackingService } from 'src/app/private/services/tracking.service';


@Component({
  selector: 'app-view-forecast',
  templateUrl: './view-forecast.component.html',
  styleUrls: ['./view-forecast.component.scss']
})
export class ViewForecastComponent {
  mobileForecastFilter: boolean = false;
  initalLoadGroup = true;
  foreCastId: any;
  foreCastData: any[] = [];
  foreCastTotalAchievedAmount = 0;
  foreCastActualAmount = 0;
  currencyCode: any;
  isOpen = false;
  bulkLeadFilterLoading = false;
  isExportLoading = false;

  selectedDealPriority: any;

  pipeline_id: any;
  deal_stage: any;
  pipelines: any[] = [];
  dealStages: any[] = [];
  pipelineData: any[] = [];
  InPipeLineProgressAmount: any = 10000050;


  selectedStartDate: any = '';
  selectedEndDate: any = '';
  loading = false;
  clearLoading = false;

  minDate: any;
  maxDate: any;

  dealPriorityList: any[] = [
    'High',
    'Medium',
    'Low'
  ];

  isRowLoading :any[] = [];

  selectedDealStage: any;

  expandedRows: Set<number> = new Set();
  expandedRowDetails: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private api: ForeCastService,
    private toaster: ToastrService,
    private localStorage: LocalStorageService,
    private pipelineApi: PipeLineService,
    private tracker: TrackingService

  ) {
    this.route.params.subscribe(params => {
      this.foreCastId = params['id'];
      this.minDate = this.route.snapshot.queryParamMap.get('period_start');
      this.maxDate = this.route.snapshot.queryParamMap.get('period_end');
      this.selectedStartDate = this.route.snapshot.queryParamMap.get('period_start');
      this.selectedEndDate = this.route.snapshot.queryParamMap.get('period_end');
    });
  }

  ngAfterViewInit() {
    this.getForecast();
    this.getAllPipeline();
    this.currencyCode = this.localStorage.getClientCurrency();
     // ✅ Log view action
  this.tracker.track("View", "Forecast", `Forecast viewed with ID: ${this.foreCastId}`);
  }

  getForecast() {
    const payload = {
      forecast_id: this.foreCastId,
      deal_stage: this.deal_stage,
      deal_priority: this.selectedDealPriority,
      period_start: this.selectedStartDate,
      period_end: this.selectedEndDate,
    }

    this.api.getforecastAnalytics(payload).subscribe({
      next: (res) => {
        this.foreCastData = res;

        this.isRowLoading = this.foreCastData.map(() => false);
        this.expandedRowDetails = this.foreCastData.map(() => []);

        this.foreCastTotalAchievedAmount = this.foreCastData.reduce((acc: any, item: any) => {
          return acc + item.achieved_amount;
        }, 0);

        this.foreCastActualAmount = this.foreCastData?.[0]?.forecast_amount || 0;

        this.initalLoadGroup = false;
        this.bulkLeadFilterLoading = false;
        this.clearLoading = false;
      },
      error: (err) => {
        this.bulkLeadFilterLoading = false;
        this.toaster.error(err.message);
        this.clearLoading = false;
      }
    });
  }


  applyBulkFilter() {
    this.bulkLeadFilterLoading = true;
    const desc = `Applied filters: Deal Stage - ${this.deal_stage}, Deal Priority - ${this.selectedDealPriority}, Start Date - ${this.selectedStartDate}, End Date - ${this.selectedEndDate}`;
    this.tracker.track("Filter", "Forecast", desc);
    this.getForecast();
    console.log("applyBulkFilter");
    this.mobileForecastFilter = false;
    if(window.innerWidth <=768){
      this.isOpen = false;
    }
  }

  clearFilter() {
    this.clearLoading = true;
    this.deal_stage = '';
    this.selectedDealPriority = '';
    this.selectedStartDate = this.minDate;
    this.selectedEndDate = this.maxDate;
    this.tracker.track("Filter", "Forecast", `Forecast filters cleared`);
    this.getForecast();
  }

  export() {
    console.log("export");
    this.tracker.track("Export", "Forecast", `Forecast exported for ID: ${this.foreCastId}`);

    const exportData = this.foreCastData?.map(item => ({
      'Team Name': item.team_name,
      'First Name': item.fname,
      'Last Name': item.lname,
      'Achieved Amount': item.achieved_amount,
      'Forecast Amount': item.forecast_amount,
      'Forecast Start Month': item.forecast_beginning_month.trim()
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = {
      Sheets: { 'Forecast Report': worksheet },
      SheetNames: ['Forecast Report']
    };

    const excelBuffer: ArrayBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    // Create a blob and download link
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'Forecast_Report.xlsx';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(url);

  }


  getAllPipeline() {
    let param = {
      client_id: this.localStorage.getClientId(),
      pipeline_type: 'deal',
    };
    this.pipelineApi.getAllPipeLine(param).subscribe({
      next: (res: any) => {
        this.pipelineData = res;
        this.pipelines = res?.map((item: any) => item.pipeline_name);

        if (this.pipelines.length > 0) {
          this.pipeline_id = this.pipelines[0];
          this.getDealStages({ target: { value: this.pipelines[0] } });
        }
      },
      error: (e: any) => {
        console.error(e);
      },
    });
  }


  onStartDateChange(): void {
    // If start date is after end date, reset end date
    if (this.selectedEndDate && this.selectedStartDate > this.selectedEndDate) {
      this.selectedEndDate = '';
    }
  }

  onEndDateChange(): void {
    // Ensure end date is after start date
    if (this.selectedStartDate && this.selectedEndDate < this.selectedStartDate) {
      alert('End date must be after start date.');
      this.selectedEndDate = '';
    }
  }


  getDealStages(e: any): void {
    const pipelineId = e.target.value;
    console.log('pipelineId', e?.target?.value);
    console.log('pipelineData', this.pipelineData);

    let stages = this.pipelineData.filter((item: any) => item.pipeline_name === pipelineId);
    console.log('stages', stages);
    if (stages.length > 0) {
      this.dealStages = stages[0].stages;
    }
  }


  toggleRow(index: number) {
    if (this.expandedRows.has(index)) {
      this.expandedRows.delete(index);
    } else {
      this.expandedRows.add(index);
      this.tracker.track("Expand", "Forecast", `Viewing deals for user: ${this.foreCastData[index].user_id}`);

      this.isRowLoading[index] = true;

      this.getUserDealDetails(index);
    }
  }

  getUserDealDetails(index: number) {
//     {
//     "where": {
//         "client_id": "4",
//         "deal_owner": 18
//     },
//     "period_start": "2025-04-01",
//     "period_end": "2026-07-31"
// }
    const payload = {
      where: {
        client_id: this.localStorage.getClientId(),
        deal_owner: this.foreCastData[index].user_id
      },
      period_start: this.selectedStartDate,
      period_end: this.selectedEndDate
    }

    this.api.getAllDealByUser(payload).subscribe({
      next: (res) => {
        this.expandedRowDetails[index] = res;
        this.isRowLoading[index] = false;
      },
      error: (err) => {
        this.isRowLoading[index] = false;
        this.toaster.error(err.message);
      }
    });
  }

  toggleForecastDetail(){
    this.mobileForecastFilter = !this.mobileForecastFilter;
  }
  @HostListener('window:resize', ['$event'])
    onResize(event: Event) {
      if (window.innerWidth > 768 && this.mobileForecastFilter) {
        this.mobileForecastFilter = false;
      }
    }

}
